import { render, staticRenderFns } from "./LiveConversationDescription.vue?vue&type=template&id=e0129c74&scoped=true"
import script from "./LiveConversationDescription.vue?vue&type=script&lang=js"
export * from "./LiveConversationDescription.vue?vue&type=script&lang=js"
import style0 from "./LiveConversationDescription.vue?vue&type=style&index=0&id=e0129c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0129c74",
  null
  
)

export default component.exports